import { useFlagsStatus } from '@unleash/proxy-client-react'

import { isUnleashConfigured } from './config'

/**
 * True once Unleash has loaded its flags — or immediately when the frontend API
 * is unconfigured, since the client then never starts (so `flagsReady` would
 * stay false forever) and the bootstrap values are the source of truth.
 *
 * Gate redirect decisions on this: a render path that navigates based on a flag
 * must wait until the real value is known, or it will bounce a targeted session
 * on the bootstrap default before the server value arrives.
 */
export const useFeatureFlagsReady = (): boolean => {
  const { flagsReady } = useFlagsStatus()

  return !isUnleashConfigured || flagsReady
}
